<div class="toast-container">
  @for (toast of toasts$ | async; track $index) {
    <div [class]="'toast toast-' + toast.type" animate.enter="enter-toast" animate.leave="leave-toast">
      <div class="toast-content">
        <!--      <mat-icon class="toast-icon">{{ getIcon(toast.type) }}</mat-icon>-->
        <span class="toast-message font-semibold text-local-normal">{{ toast.message }}</span>
      </div>
      <button (click)="onClose(toast.id)" class="toast-close">
        x
      </button>
    </div>
  }
</div>
